import { AxiosPromise } from 'axios';
import Api, { baseURL } from '../../configs/AxiosConfig';
import {
  DevicesReportColumnsResponse,
  DevicesReportFilter,
  DevicesReportFiltersResponse,
  DevicesReportRequest,
  DevicesReportResponse,
  UnassignedDevicesReportResponse,
  DevicesStatusResponse,
} from '../../models/DevicesReportModels';
import { FileFormat } from '../../models/ImportModels';
import { downloadFile } from '../../utils/files/downloadFile';

const DevicesReportService = {
  api: {
    fetchDevicesStatusTypes: (): AxiosPromise<DevicesStatusResponse> => Api.get(`/devices/report/status`),
    fetchDevicesReport: (params: DevicesReportRequest): AxiosPromise<DevicesReportResponse> =>
      Api.post(`/devices/report/list`, params),
    fetchUnassignedDevicesReport: (params: DevicesReportRequest): AxiosPromise<UnassignedDevicesReportResponse> =>
      Api.post(`/devices/unassigned/list`, params),
    fetchTableColumns: (): AxiosPromise<DevicesReportColumnsResponse> => Api.get(`/devices/report/columns`, {}),
    fetchUnassignedTableColumns: (): AxiosPromise<DevicesReportColumnsResponse> =>
      Api.get(`/devices/unassigned/columns`, {}),
    fetchFilters: (): AxiosPromise<DevicesReportFiltersResponse> => Api.get(`/devices/report/filters`, {}),
    exportData: (filter: DevicesReportFilter, format: FileFormat, fileName: string): Promise<void> => {
      // Build query string from params and format
      const queryParams = new URLSearchParams();

      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      });
      queryParams.append('format', format.toUpperCase());

      return downloadFile({
        url: `${baseURL}/devices/report/export?${queryParams.toString()}`,
        filename: fileName,
      });
    },
  },
};

export default DevicesReportService;
